<div class="export-control">
	<button
		type="button"
		class="export-trigger"
		aria-label="Exportar conversa"
		title="Exportar conversa"
		aria-haspopup="menu"
		aria-controls="chat-export-menu"
		[attr.aria-expanded]="menuAberto"
		(click)="alternarMenu()">
		<mat-icon svgIcon="file_download"></mat-icon>
		<span>Exportar conversa</span>
	</button>

	<div *ngIf="menuAberto" id="chat-export-menu" class="export-menu" role="menu" aria-label="Opções de exportação">
		<div class="export-menu-heading">Como deseja receber a conversa?</div>
		<button type="button" class="export-option" role="menuitem" (click)="downloadConversa()">
			<mat-icon svgIcon="file_download"></mat-icon>
			<span>Baixar conversa</span>
		</button>
		<button type="button" class="export-option" role="menuitem" (click)="selecionarCanal(0)">
			<mat-icon svgIcon="mail"></mat-icon>
			<span>Enviar por e-mail</span>
		</button>
		<button *ngIf="whatsappHabilitado" type="button" class="export-option" role="menuitem" (click)="selecionarCanal(1)">
			<span class="whatsapp-mark" aria-hidden="true">WA</span>
			<span>Enviar pelo WhatsApp</span>
		</button>

		<div *ngIf="canalSelecionado === 0" class="export-contact-form">
			<label for="export-contact">
				{{ canalSelecionado === 0 ? 'E-mail' : 'WhatsApp com código do país' }}
			</label>
			<small *ngIf="canalSelecionado === 1">Digite o código do país e o número, sem o sinal +. Exemplo: 55 11 99999-9999.</small>
			<div class="export-phone-input" [class.with-prefix]="canalSelecionado === 1">
				<span *ngIf="canalSelecionado === 1" class="phone-prefix" aria-hidden="true">+</span>
				<input
					id="export-contact"
					[type]="canalSelecionado === 0 ? 'email' : 'tel'"
					[attr.autocomplete]="canalSelecionado === 0 ? 'email' : 'tel'"
					[attr.inputmode]="canalSelecionado === 1 ? 'tel' : 'email'"
					[attr.aria-invalid]="canalSelecionado === 0 && contato.length > 0 && !contatoValido"
					[attr.aria-describedby]="canalSelecionado === 0 && contato.length > 0 && !contatoValido ? 'export-contact-error' : null"
					required
					[placeholder]="canalSelecionado === 0 ? 'nome@exemplo.com' : '55 11 99999-9999'"
					[value]="contato"
					(input)="atualizarContato($event)" />
			</div>
			<small *ngIf="canalSelecionado === 0 && contato.length > 0 && !contatoValido" id="export-contact-error" class="field-error" role="alert">
				Digite um e-mail válido.
			</small>
			<button type="button" class="export-confirm" [disabled]="!contatoValido" (click)="confirmarEnvio()">
				{{ uploadConcluido ? 'Arquivo enviado' : 'Confirmar envio' }}
			</button>
		</div>
	</div>
	<div *ngIf="mensagemFeedback" class="export-feedback" [class.export-feedback-error]="feedbackErro" role="status" aria-live="polite">
		{{ mensagemFeedback }}
	</div>
</div>
